import script from "./ChaseupCallsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChaseupCallsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChaseupCallsModal.vue?vue&type=style&index=0&id=745a431c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-745a431c"]])

export default __exports__